<template lang="pug">
  div.main
    el-form(
      :model="size"
      label-width="90px"
      :rules="sizeRules"
      :size="GLOBAL.SIZE_OF_INPUTBOX"
      ref="sizeRef")
      el-row
        el-col(:span="20")
          el-form-item(label="标题" prop="title" )
            el-input(v-model="size.title")
      el-row
        el-col(:span="20")
          el-form-item(label="描述" prop="description")
            el-input(v-model="size.description" type="textarea")
      el-row
        el-col(:span="10")
          el-form-item(label="权威" )
            el-select(placeholder="请选择" v-model="size.authority" clearable allow-create)
              el-option(label="非权威" :value="0")
              el-option(label="第三方" :value="1")
              el-option(label="权威" :value="2")
        //- el-col(:span="10")
        //-   el-form-item(label="状态" )
        //-     el-select(placeholder="请选择" v-model="size.status" clearable)
        //-       el-option(label="草稿" :value="0")
        //-       el-option(label="完成" :value="1")
      el-row
        el-col(:span="10")
          el-form-item(label="来源" )
            el-input(v-model="size.source")
        el-col(:span="10")
          el-form-item(label="URL" )
            el-input(v-model="size.sourceUrl")
      el-row
        //- el-col(:span="10")
        //-   el-form-item(label="行业" )
        //-     FrostIndustry(v-model="size.industryId" v-bind:name="size.industry")
        el-col(:span="10")
          el-form-item(label="显示" )
            el-radio-group(v-model="size.barType")
              el-radio(:label="0") 分组
              el-radio(:label="1") 堆叠
      el-row
        el-col(:span="10")
          el-form-item(label="厂牌")
            brandSelect(v-model="size.brand" :brandName="size.brandName" @brandName="getbrandName")
      el-row
        el-col(:span="10")
          el-form-item(label="设置")
            el-button(type="primary" @click="showXDialog" :size="GLOBAL.SIZE_OF_INPUTBOX" :disabled="size.status > 0") x轴刻度
    .sheets
      el-dialog(title="设置X轴刻度" :visible.sync="xUnitDialog" width="800px" @close="cancelX")
        el-form.dialogForm(:model='dialogDetail')
          el-row( type="flex" class="row-bg" justify="center")
            el-col(:span="11")
              el-form-item.radio
                el-radio-group(v-model="dialogDetail.xDataClass")
                  el-radio(label="数字" )
                  el-radio(label="非数字")
            el-col(:span="11")
              el-form-item.unit(label="单 位:")
                el-input(v-model="size.XunitName" style="width:80px" :size="GLOBAL.SIZE_OF_INPUTBOX")
          el-row.number(v-show="dialogDetail.xDataClass=='数字'" type="flex" class="row-bg" justify="center" )
            el-col(:span="11")
              el-form-item(label="刻度范围")
                el-input(v-model="dialogDetail.xDatafirst" style="width:80px" :size="GLOBAL.SIZE_OF_INPUTBOX")
                span(style='margin:0 10px')|至
                el-input(v-model="dialogDetail.xDatalast" style="width:80px" :size="GLOBAL.SIZE_OF_INPUTBOX")
            el-col(:span="11")
              el-form-item.input(label="间 隔:")
                el-input(v-model="dialogDetail.xDataDistance" style="width:80px" :size="GLOBAL.SIZE_OF_INPUTBOX" )
            el-button(style="position:absolute;right:0;top:7px" type="success" :size="GLOBAL.SIZE_OF_INPUTBOX" @click="createX") 生成
          el-row(style="margin-left:30px")
            el-form-item
              el-input(v-for="(x, index) in xData" style="width:100px;margin-right:20px" :size="GLOBAL.SIZE_OF_INPUTBOX" v-model='xData[index]' clearable @clear='clearX(index)' :key='index' @keypress.enter.native="addX")
              el-button(type="success" :size="GLOBAL.SIZE_OF_INPUTBOX" @click="addX") +
              el-button(type="success" :size="GLOBAL.SIZE_OF_INPUTBOX" @click="addXs") Excel粘贴
        div(slot="footer" class="dialog-footer")
          el-button(@click="cancelX" :size="GLOBAL.SIZE_OF_INPUTBOX"  ) 取 消
          el-button(type="primary" @click="handleSetX" :size="GLOBAL.SIZE_OF_INPUTBOX" ) 确 定
      DataSheet(style="margin:5px 5px" v-if="!xUnitDialog" v-for="(item,index) in size.products" :key="index" :single="item" :index="index" :xData='xData' :XunitName='size.XunitName' @remove="removeDatasheet" :ref="'item' + index" :class="'item' + index")
    el-row(type="flex" justify="end")
      el-button-group(style="margin:10px 0px")
        el-button(type="primary" @click="handleSave" :size="GLOBAL.SIZE_OF_INPUTBOX" :disabled="size.status > 0") 保存
        el-button(type="info" @click="handleLook" :size="GLOBAL.SIZE_OF_INPUTBOX" :disabled="showEcharts" v-if="!attachmentInfo") 预览
        el-button(type="success" @click="addDatasheet" :size="GLOBAL.SIZE_OF_INPUTBOX" :disabled="size.status > 0" ) 增加数据表
    el-dialog(:visible.sync="dialogVisible" @close="handelClose")
      drawSziePro(:dialogData="size" ref="drawSziePro" :barType="size.barType")
</template>

<script>
import brandSelect from '@/components/brandSelect'
import drawSziePro from './drawsizePro'
import FrostIndustry from '@/components/industry'
import DataSheet from '../components/DataSheet'
import apis from '@/apis/attachment'
import async from 'async'
import Enum from '@/apis/enum'
export default {
  components: { FrostIndustry, DataSheet, drawSziePro, brandSelect },

  data () {
    return {
      sizeRules: {
        title: [{ required: true, message: '请输入标题', trigger: 'blur' }],
        description: { required: true, message: '请输入描述', trigger: 'blur' }
      },
      size: {
        title: '',
        description: '',
        authority: '',
        status: 0,
        source: '',
        sourceUrl: '',
        industry: [],
        industryId: [],
        kind: 0,
        barType: 0,
        products: [],
        brandName: '',
        XunitName: ''
      },
      dialogDetail: {
        xDataClass: '数字',
        xDatafirst: '',
        xDatalast: '',
        xDataDistance: ''
      },
      xData: [],
      xTempData: [],
      isAdd: true,
      xUnitDialog: false,
      source: Enum.SOURCE,
      dialogVisible: false,
      showEcharts: true
    }
  },
  props: {
    attachmentInfo: {
      type: Object,
      default: () => {}
    }
  },
  created () {
    if (!this.attachmentInfo) {
      this.getSize()
    } else {
      const title = this.attachmentInfo.newTitle || this.attachmentInfo.title
      // delete this.attachmentInfo.newTitle
      // delete this.attachmentInfo.title
      // this.size = this.attachmentInfo
      this.size.title = title
      this.size._id = this.attachmentInfo._id
      this.size.description = this.attachmentInfo.description
      this.size.authority = this.attachmentInfo.authority
      this.size.status = this.attachmentInfo.status
      this.size.source = this.attachmentInfo.source
      this.size.sourceUrl = this.attachmentInfo.sourceUrl
      this.size.industry = this.attachmentInfo.industry
      this.size.industryId = this.attachmentInfo.industryId
      this.size.kind = this.attachmentInfo.kind
      this.size.barType = this.attachmentInfo.barType
      this.size.products = this.attachmentInfo.products
      this.size.brandName = this.attachmentInfo.brandName
      this.attachmentInfo.products[0].series.map(item => {
        this.xData.push(item.year)
      })
    }
  },
  methods: {
    showXDialog () {
      this.xTempData = JSON.parse(JSON.stringify(this.xData))
      this.xUnitDialog = !this.xUnitDialog
    },
    addX () {
      this.xData.push('')
    },
    createX () {
      this.xData = []
      if (this.dialogDetail.xDatafirst !== '' && this.dialogDetail.xDatalast !== '' && this.dialogDetail.xDataDistance !== '') {
        for (let i = 0; i <= (parseInt(this.dialogDetail.xDatalast) - parseInt(this.dialogDetail.xDatafirst)) / parseInt(this.dialogDetail.xDataDistance); i++) {
          this.xData[i] = (parseInt(this.dialogDetail.xDatafirst) + i * parseInt(this.dialogDetail.xDataDistance)).toString()
        }
      } else {
        this.$message({
          type: 'warning',
          message: '请正确输入!'
        })
      }
    },
    clearX (i) {
      this.xData.splice(i, 1)
    },
    cancelX () {
      this.xData = JSON.parse(JSON.stringify(this.xTempData))
      this.xUnitDialog = false
    },
    async addXs () {
      // eslint-disable-next-line no-useless-escape
      const patten = /[\-*\S+\.*\S*]+/g
      try {
        const r = await this.$prompt(
          '请复制单列或者单行的数据，粘贴到下面到文本框中',
          'Excel粘贴',
          {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            inputPattern: patten,
            inputErrorMessage: '数据格式不正确'
          }
        )
        const sizes = r.value.match(patten)
        if (sizes.length === 0) return
        this.xData = []
        for (let i = 0; i < sizes.length; i++) {
          this.xData.push(sizes[i])
        }
      } catch (err) {
        console.log(err)
      }
    },
    handleSetX () {
      if (this.xData.length > 0) {
        this.xTempData = JSON.parse(JSON.stringify(this.xData))
        this.xUnitDialog = false
      } else {
        this.$message({
          type: 'warning',
          message: '请输入x轴刻度!'
        })
      }
    },
    getbrandName (brandName) {
      this.size.brandName = brandName
    },
    async handleSave () {
      const check = await this.checkDataSheet()
      const id = this.$route.query.id
      const kindArr = this.size.products.map(item => item.kind)
      const newSetKind = [...new Set(kindArr)]
      if (newSetKind.length > 1 && newSetKind.includes(0)) {
        this.$message({
          message: '产品的种类pei不可和bar/line混用，请重新选择',
          type: 'error'
        })
      } else {
        if (!check) {
          return
        }
        this.$refs.sizeRef.validate(valid => {
          if (valid && this.isAdd) {
            if (!id) {
              apis
                .saveSize(this.size)
                .then(r => {
                  const { _id } = r.data
                  this.$emit('update:mainId', _id)
                  this.$router.replace('/size/SizePro/From?id=' + _id)
                  this.getSize()
                  this.$message({
                    message: '新建成功',
                    type: 'success'
                  })
                })
                .catch(err => {
                  this.$message({
                    message: err,
                    type: 'error'
                  })
                })
            } else {
              this.size.brand =
                this.size.brandName === '' ? null : this.size.brand
              apis
                .updateSize(this.size)
                .then(r => {
                  if (this.attachmentInfo) {
                    this.$emit('cancel', this.size)
                  } else {
                    const { _id } = r.data
                    this.$emit('update:mainId', _id)
                    this.getSize()
                  }
                  this.$message({
                    message: '更新成功',
                    type: 'success'
                  })
                })
                .catch(err => {
                  this.$message({
                    message: err,
                    type: 'error'
                  })
                })
            }
          }
        })
      }
    },
    addDatasheet () {
      const newSize = JSON.parse(JSON.stringify(this.size))
      this.size.products.push({
        unit: 1,
        unitName: '人民币元',
        series: [],
        industryId: newSize.industryId,
        industry: newSize.industry,
        yAxis: 0,
        kind: 1,
        dialogDetail: this.dialogDetail
      })
      this.$nextTick(() => {
        const length = this.size.products.length - 1
        document.querySelector(`.item${length}`)
        // a.scrollIntoView(true)
      })
    },
    removeDatasheet (index) {
      this.size.products.splice(index, 1)
    },
    handleLook () {
      this.dialogVisible = true
    },
    getSize () {
      const id = this.$route.query.id
      if (id) {
        apis.getSizePro({ id }).then(res => {
          if (res.errCode !== 0) {
            this.$router.replace('/size/SizePro')
            this.isAdd = false
            return
          }
          this.size = res.data
          this.xData = []
          res.data.products[0] && res.data.products[0].series.map(item => {
            this.xData.push(item.year)
          })
        })
      }
    },
    checkDataSheet () {
      const checkDatasheet = []
      for (let i = 0; i < this.size.products.length; i++) {
        checkDatasheet.push(cb => {
          this.$refs['item' + i][0]
            .verifyForm()
            .then(r => {
              cb(null, true)
            })
            .catch(err => {
              cb(new Error(err))
            })
        })
      }
      return new Promise((resolve, reject) => {
        async.parallel(checkDatasheet, (err, results) => {
          if (err) {
            reject(err)
          } else {
            resolve(this.size)
          }
        })
      })
    },
    handelClose () {
      this.dialogVisible = false
    }
  },
  watch: {
    size: {
      handler: function (val) {
        if (this.size.products.length === 0) {
          this.showEcharts = true
        } else {
          this.showEcharts = true
          const kindArr = this.size.products.map(item => item.kind)
          const newSetKind = [...new Set(kindArr)]
          if (newSetKind.length > 1 && newSetKind.includes(0)) {
            this.$message({
              message: '产品的种类pei不可和bar/line混用，请重新选择',
              type: 'error'
            })
          } else {
            this.showEcharts = false
          }
        }
      },
      deep: true,
      immediate: true
    }
  }
}
</script>

<style scoped>
.sheets {
  display: flex;
  flex-flow: row wrap;
}
.dialogForm,.number{
  position: relative;
}
.unit,.input{
  width: 200px;
  position: absolute;
  right: 0;
  top: 0;
  /* margin-left: 200px; */
}

</style>
